import styled from 'styled-components';
import {
    colorLightBlue,
    colorExtraDark,
    colorWhite
} from '@client/styles/styled-components/variables';
import { screenUpTo, Screen } from '@client/styles/styled-components/breakpoints';

export const WrapperSection = styled.section`
    width: ${comp => comp.theme.width};
    min-height: ${comp => comp.theme.minHeight};
    background-color: ${comp => comp.theme.backgroundColor};
    display: flex;
    align-items: center;
    flex-direction: row;
    margin-top: ${comp => comp.theme.marginTop};
    margin-bottom: ${comp => comp.theme.marginBottom};
    padding-top: ${comp => comp.theme.paddingTop};
    padding-right: ${comp => comp.theme.paddingRight};
    padding-bottom: ${comp => comp.theme.paddingBottom};
    padding-left: ${comp => comp.theme.paddingLeft};
    color: ${colorExtraDark};
    .icon {
        width: ${comp => comp.theme.iconWidth};
        ${screenUpTo(Screen.mobile)}{
            width: 96px;
            height: 35px;
        }
        height: 33px;
        margin-right: 12px
    }
    .icon--small {
        width: 16px;
        height: 16px;
        margin: 0 8px;
    }
`;

WrapperSection.defaultProps = {
    theme: {
        marginTop: '0px',
        marginBottom: '30px',
        backgroundColor: `${colorLightBlue}`,
        paddingTop: '12px',
        paddingBottom: '12px',
        paddingRight: '12px',
        paddingLeft: '12px',
        iconWidth: '31px'
    },
};

export const articleDetail = {
    marginTop: '40px',
    marginBottom: '40px',
    backgroundColor: `${colorLightBlue}`,
    iconWidth: '96px',
    paddingTop: '12px',
    paddingBottom: '12px',
    paddingRight: '12px',
    paddingLeft: '12px',
};

export const mylounge = {
    width: 'max-content',
    marginBottom: '10px',
    backgroundColor: `${colorWhite}`,
    lineHeight: '18px',
    minHeight: '0px',
    paddingTop: '4px',
    paddingRight: '8px',
    paddingBottom: '4px',
};
